import React from 'react'
import PropTypes from 'prop-types'
import { normalizeRatingTenths, formatRatingOutOfFive, starFillFractions } from './overallRatingUtils'

export interface OverallRatingProps {
  ratingLabel: string // This should be stricter, but requires refactoring Const.RATING_TYPES
  value: number
}

export const OverallRating = ({ ratingLabel, value }: OverallRatingProps): React.ReactElement => {
  const ratingLabelDisplay = `${ratingLabel} Rating`

  const normalized = normalizeRatingTenths(value)
  const displayRatingValue = formatRatingOutOfFive(normalized)
  const fills = starFillFractions(normalized)

  return (
    <div className='overall-rating-box'>
      <div className='color-pro-steel-grey-600 font-bold pro-text-xs'>
        {ratingLabelDisplay}
      </div>

      <div className='overall-rating-stars' aria-label={`${displayRatingValue} out of 5`}>
        {fills.map((fill, i) => (
          <span key={i} className='overall-rating-star'>
            <span className='overall-star-base' />
            <span className='overall-star-fill' style={{ width: `${fill * 100}%` }} />
          </span>
        ))}
      </div>

      <div>
        <span className='bold pro-text-s'>{displayRatingValue} out of 5</span>
      </div>
    </div>
  )
}

OverallRating.propTypes = {
  ratingLabel: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired
}
